import React, { useState } from "react";
import { Accordion, AccordionSummary } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import styles from "./DealerShipDetails.module.scss";
import crStyles from "../../customerReservation/crStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Button from "@mui/material/Button";
import {
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import Grid from "@mui/material/Grid";
import Clear from "@mui/icons-material/Clear";
import EditIcon from "../../../shared/Edit/EditIcon";
import { withTranslation } from "react-i18next";
import DealerEmployeeTable from "./DealerEmployeeTable";
import HasPermissionTo from "../../../common/HasPermissionTo";
import DealerDetailsClient from "../../../shared/clients/DealerDetailsClient";
import AppActionsLogClient from "../../../shared/clients/AppActionsLogClient";
import { GET_DEALER_NAME } from "../../../utils/EmpUtil";

const StyledExpansionPanelSummary = withStyles({
  content: {
    margin: 0,
    "&$expanded": {
      margin: 0,
    },
  },
  expanded: {
    margin: 0,
  },
})(AccordionSummary);

function DealerContactInfo(props) {
  const [expand, setExpand] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [currentEmailText, setCurrentEmailText] = useState(props.dealers.emailAddress);
  const [currentPhoneText, setCurrentPhoneText] = useState(props.dealers.phoneNumber);
  const [emailText, setEmailText] = useState(props.dealers.emailAddress);
  const [phoneText, setPhoneText] = useState(props.dealers.phoneNumber);

  const dealer = props.dealers;
  const showAddress = props.user.permissions.rolePermissions.hasOwnProperty(
    "businessAddress:view"
  );

  const flipIcon = () => {
    setExpand(!expand);
  };

  const cancelEdit = () => {
    setEditMode(false);
    setEmailText(currentEmailText);
    setPhoneText(currentPhoneText);
  };

  const updateEmailAndPhone = (dealerId) => {
    const emailIdValue = document.getElementById(
      "emailInput_" + dealerId
    ).value;

    DealerDetailsClient.updateDealerEmailAddress(
      props.user,
      dealerId,
      emailIdValue
    )
      .then(() => {
        setEmailText(emailIdValue);
        setCurrentEmailText(emailIdValue);
      })
      .then(() => {
        updatePhone(dealerId, emailIdValue);
      })
      .then(() => {
        const payload = {
          userId: props.user.userId,
        };

        AppActionsLogClient.recordEmailPhoneUpdatedAction(
          props.user,
          payload
        )
          .then(() => {})
          .catch(() => {});
      })
      .catch(() => {});
  };

  const updatePhone = (completeDealerId, emailIdValue) => {
    const phoneNumValue = document.getElementById(
      "phoneInput_" + completeDealerId
    ).value;

    DealerDetailsClient.updateDealerPhoneNumber(
      props.user,
      completeDealerId,
      phoneNumValue
    )
      .then((dealer) => {
        setPhoneText(phoneNumValue);
        setCurrentPhoneText(phoneNumValue);
        setEditMode(false);
        props.updateDealerPhoneAndEmail(
          dealer,
          emailIdValue,
          phoneNumValue
        );
      })
      .catch(() => {});
  };

  const editDealershipInfo = () => {
    setEditMode(true);
  };

  const emailOnChange = (event) => {
    setEmailText(event.target.value);
  };

  const phoneOnChange = (event) => {
    setPhoneText(event.target.value);
  };

  const getBusinessAddress = (props, dealer) => {
    return props.user.market.toUpperCase() === "DEU" ? (
      <Grid item md={3} className={styles.divAddress}>
        <span>{dealer.address.street} </span>
        <span>
          {dealer.address.postalCode}&nbsp;
          {dealer.address.city}
        </span>
        <span> {dealer.address.country}</span>
      </Grid>
    ) : props.user.market.toUpperCase() === "VNM" ? (
      dealer.localAddress ? (
        <Grid item md={3} className={styles.divAddress}>
          <span>{dealer.localAddress.street} </span>
          <span>
            {" "}
            {dealer.localAddress.city}, {dealer.localAddress.stateDesc}{" "}
          </span>
          <span>
            {" "}
            {dealer.localAddress.country},{dealer.localAddress.postalCode}
          </span>
        </Grid>
      ) : (
        <Grid item md={3} className={styles.divAddress}>
          <span>{dealer.address.street} </span>
          <span>
            {" "}
            {dealer.address.city}, {dealer.address.stateDesc}{" "}
          </span>
          <span>
            {" "}
            {dealer.address.country},{dealer.address.postalCode}
          </span>
        </Grid>
      )
    ) : (
      <Grid item md={3} className={styles.divAddress}>
        <span>{dealer.address.street} </span>
        <span> {dealer.address.city}</span>
        <span>
          {" "}
          {dealer.address.country},{dealer.address.postalCode}
        </span>
      </Grid>
    );
  };

  const dealerId = dealer.dealerId;

  return (
    <div className={styles.divPadding}>
      <Accordion
        classes={{ root: styles.expPanelNoBoxShadow }}
        style={{ marginBottom: "10px" }}
        defaultExpanded={true}
        onChange={() => flipIcon()}
      >
        <StyledExpansionPanelSummary style={crStyles.headerBarBg} id="exp">
          <div className={styles.headerBar}>
            <div>
              {GET_DEALER_NAME(dealer, props.user.market)}
              <span>({dealerId})</span>
            </div>
            {expand ? (
              <ExpandLessIcon id="less" />
            ) : (
              <ExpandMoreIcon id="more" />
            )}
          </div>
          <br />
        </StyledExpansionPanelSummary>
        <div className={styles.borderBottom} />
        <div className={styles.businessDetailsContainer}>
          <div className={styles.sectionHeaderDealership}>
            {props.t("DealerShipDetails.dealershipHeader")}
          </div>
          <div className={styles.subHeader}>
            <HasPermissionTo
              perform={["businessAddress:view"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => (
                <span
                  id="businessDetails"
                  className={styles.businessDetailsInputGridModel}
                >
                  {props.t("DealerShipDetails.businessDetails")}
                </span>
              )}
            />
          </div>
          <ValidatorForm
            style={{ width: "100%" }}
            onSubmit={() =>
              updateEmailAndPhone(dealer.completeDealerId)
            }
          >
            <Grid
              container
              className={!showAddress ? styles.addressFlex : ""}
            >
              <HasPermissionTo
                perform={["businessAddress:view"]}
                permissions={props.user.permissions.rolePermissions}
                render={() =>
                  getBusinessAddress(props, dealer)
                }
              />
              <>
                {editMode ? (
                  <Grid item md={3} className={styles.divEmail}>
                    <TextValidator
                      value={emailText}
                      onChange={emailOnChange}
                      variant="outlined"
                      style={{ width: "70%" }}
                      name={"emailInput_" + dealer.completeDealerId}
                      id={"emailInput_" + dealer.completeDealerId}
                      validators={["required", "isEmail"]}
                      errorMessages={[
                        props.t("Error.requiredField"),
                        props.t("Error.invalidInput"),
                      ]}
                    />
                  </Grid>
                ) : (
                  <Grid item md={3} className={styles.divEmail}>
                    {emailText ? (
                      <span className={styles.emailText}>
                        {emailText}
                      </span>
                    ) : (
                      props.t("DealerShipDetails.emailAddress")
                    )}
                  </Grid>
                )}
                {editMode ? (
                  <Grid
                    item
                    md={3}
                    className={`${styles.divPhone} editPhoneReady`}
                  >
                    <TextValidator
                      variant="outlined"
                      style={{ width: "60%" }}
                      onChange={phoneOnChange}
                      value={phoneText}
                      name={"phoneInput_" + dealer.completeDealerId}
                      id={"phoneInput_" + dealer.completeDealerId}
                      validators={["required"]}
                      errorMessages={[props.t("Error.requiredField")]}
                    />
                  </Grid>
                ) : (
                  <Grid
                    item
                    md={3}
                    className={`${styles.divPhone} editPhoneOn`}
                  >
                    {phoneText ? (
                      <span className={styles.phoneText}>
                        {phoneText}
                      </span>
                    ) : (
                      props.t("DealerShipDetails.phoneNumber")
                    )}
                  </Grid>
                )}
                <Grid
                  item
                  md={3}
                  className={
                    showAddress
                      ? styles.contactEditDiv
                      : styles.contactEditDivNoAddress
                  }
                >
                  {editMode ? (
                    <>
                      <Button id={"confirmInfo_" + dealerId} type="submit">
                        <div className={styles.confirm}>OK</div>
                      </Button>
                      <Button
                        id={"cancelInfo_" + dealerId}
                        onClick={cancelEdit}
                      >
                        <Clear />
                      </Button>
                    </>
                  ) : (
                    <HasPermissionTo
                      perform={["dealershipEmailDetails:write"]}
                      permissions={
                        props.user.permissions.rolePermissions
                      }
                      condition={
                        !props.isMainViewingSDLR(props.dealers)
                      }
                      render={() => (
                        <Button
                          id={`Edit_${dealerId}`}
                          onClick={editDealershipInfo}
                        >
                          <EditIcon />
                        </Button>
                      )}
                    />
                  )}
                </Grid>
              </>
            </Grid>
          </ValidatorForm>
        </div>
        <DealerEmployeeTable {...props} />
      </Accordion>
    </div>
  );
}

export default withTranslation("emp")(DealerContactInfo);
